<template>
	<div class="admin-and-legal-fee">
		<b-form role="form" class="mt-4">
			<b-row>
				<b-col md="8" cols="12">
					<b-form-group label="Fees Calculation Type">
						<b-form-radio-group v-model="form.calculation_type">
							<b-form-radio value="manual" :disabled="is_readonly">Manual</b-form-radio>
							<b-form-radio value="auto" disabled>Auto (WIP)</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</b-col>
				<!-- <b-col md="8" cols="12">
					<b-form-group label="Admin Fees (RM)">
						<CurrencyInput v-model="form.admin_fee_amt" :disabled="is_readonly"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col> -->
				<b-col md="8" cols="12" v-if="form.calculation_type == 'auto'">
					<b-form-group label="Stamping Fee">
						<b-form-radio-group v-model="form.stamping_fee_prc">
							<b-form-radio value="0.00" :disabled="is_readonly">0%</b-form-radio>
							<b-form-radio value="0.50" :disabled="is_readonly">0.5%</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12">
					<b-form-group label="Stamping Fee (RM)">
						<CurrencyInput v-model="form.stamping_fee_amt" :disabled="is_readonly"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12">
					<b-form-group label="Vetting and Facilitation Services Fees (RM)">
						<CurrencyInput v-model="form.vet_fac_amt" :disabled="is_readonly"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12">
					<b-form-group label="Stakeholder Sum (RM)">
						<CurrencyInput v-model="form.stakeholder_amt" :disabled="is_readonly"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12" v-if="form.calculation_type == 'auto'">
					<b-form-group label="Legal Fee (%)">
						<el-radio-group v-model="legal_fee" fill="#13663E">
							<el-radio-button v-for="(prc,index) in legal_fee_opt" :key="index" :label="prc" :class="(prc == legal_fee ? 'is-active':'')" :disabled="is_readonly">
								<template #default>{{ parseInt(prc)}}%</template>
							</el-radio-button>
							<el-radio-button label="Specify" :disabled="is_readonly"></el-radio-button>
						</el-radio-group>
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12" v-if="legal_fee == 'Specify' && calculation_type == 'auto'">
					<b-form-group label="Specify Legal Fee (%)">
						<b-form-input v-model="form.legal_fee_prc" type="text" maxlength="2" @keydown="preventNonNumericInput" :disabled="is_readonly">
						</b-form-input>
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12" v-if="form.calculation_type == 'auto'">
					<b-form-group label="Legal Fee Amount (RM)">
						<CurrencyInput v-model="form.legal_fee_amt" :disabled="is_readonly"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12" v-if="form.calculation_type == 'auto'">
					<b-form-group label="Legal Fee SST">
						<b-form-radio-group v-model="form.legal_sst_prc">
							<b-form-radio value="0.00" :disabled="is_readonly">0%</b-form-radio>
							<b-form-radio value="6.00" :disabled="is_readonly">6%</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</b-col>
				<b-col md="8" cols="12">
					<b-form-group label="Legal Fee (RM)">
						<CurrencyInput v-model="form.legal_cost_amt" :disabled="is_readonly"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col>
				<b-col cols="8" v-if="!is_readonly">
					<el-button class="bg-primary text-white w-50" @click.prevent="updateAll()"
						:loading="is_loading">Save</el-button>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>
<script>
import { Button, RadioButton, RadioGroup } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { preventNonNumericInput } from '@/assets/js/formValidations.js'
import { mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	props: ['activeCase','is_readonly'],
	components: {
		CurrencyInput,
		[Button.name]: Button,
		[RadioButton.name]: RadioButton,
		[RadioGroup.name]: RadioGroup,
	},
	data() {
		return {
			legal_fee: '',
			legal_fee_opt: ['0.00', '1.00', '2.00', '5.00'],
			form: {
				calculation_type: 'manual',
				admin_fee_amt: '',
				stamping_fee_prc: '',
				stamping_fee_amt: '',
				vet_fac_prc: '',
				vet_fac_sst: '',
				vet_fac_amt: '',
				stakeholder_mth: '',
				stakeholder_amt: '',
				legal_fee_prc: '',
				legal_fee_amt: '',
				legal_sst_prc: '',
				legal_cost_amt: '',
			},
			is_loading: false
		}
	},
	watch: {
		'activeCase': {
			handler(newValue, oldValue) {
				this.setForm(newValue)
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useLoanCaseStore, ['updateCase']),
		preventNonNumericInput,
		setForm(data) {
			this.form.calculation_type = data.calculation_type || 'manual';
			this.form.admin_fee_amt = data.admin_fee_amt;
			this.form.stamping_fee_prc = data.stamping_fee_prc;
			this.form.stamping_fee_amt = data.stamping_fee_amt;
			this.form.legal_fee_prc = data.legal_fee_prc;
			this.form.legal_fee_amt = data.legal_fee_amt;
			this.form.legal_sst_prc = data.legal_sst_prc;
			this.form.legal_cost_amt = data.legal_cost_amt;
			this.form.vet_fac_prc = data.vet_fac_prc;
			this.form.vet_fac_sst = data.vet_fac_sst;
			this.form.vet_fac_amt = data.vet_fac_amt;
			this.form.stakeholder_mth = data.stakeholder_mth;
			this.form.stakeholder_amt = data.stakeholder_amt;
			
			if ((this.legal_fee_opt.indexOf(data.legal_fee_prc) < 0) && !_gHlp.isEmpty(data.legal_fee_prc)) {
				this.legal_fee = 'Specify';
			} else if (!_gHlp.isEmpty(data.legal_fee_prc)) {
				this.legal_fee = data.legal_fee_prc;
			}
		},
		updateAll() {
			this.is_loading = true;
			if (this.legal_fee != 'Specify') {
				this.form.legal_fee_prc = this.legal_fee
			}

			this.updateCase(this.form).then(res => {
				_gNotif.notifySuccess("Case loan detail has been update")
				this.is_loading = false;
			});
		}
	}
}
</script>